angular.module('qkr').controller('verificationController', ($scope, utils, appConfig, FormHelper, messageService,
                                                            verificationService, $window, gettextCatalog, appUrl,
                                                            $log) => {
	const formHelper = new FormHelper($scope);

    const getLocaleLanguage = (language) => {
        // server is not treating the locale, need sent the full, the code bellow is only treating english gb,
        // but the server should send the correct locale language
        if(!language ) {
            if(gettextCatalog.currentLanguage === 'en') {
                return gettextCatalog.currentLanguage.concat('-gb')
            } else {
                return gettextCatalog.currentLanguage;
            }
        } else if(language === 'en') {
            return language.concat('-gb');
        } else {
            return language;
        }
    }

	$scope.init = function(paramVcode, partnerName, language, region, ispartner) {
    	 $scope.form = {};
         $scope.errors = {};
    	 $scope.form.vcode = {verificationCode: paramVcode};
         $scope.partnerName = partnerName;
         $scope.region = region;
         $scope.ispartner = ispartner;

        const termCondition = {
            locale: getLocaleLanguage(language),
            type: 'pn'
        };
        verificationService.getConsentLanguage(termCondition)
            .then(response => {
                $scope.consentLanguage = response.data ? response.data.value : '';
            })
            .catch(reason => $log.error(reason));
    },
	    
    $scope.verificationCallback = function(response) {
    	const r = formHelper.handleResponse(response);
    	// Fix me: At the moment completeRegistration(), if successful, logs the user in
        // And then redirects to landing page. For some reason, maybe because it's a redirect
        // Response to a ajax POST, this (finally) arrives back here as a 404. So we will
        // Redirect to the login page if we get a 404.
        if (r.isSuccess() || r.responseStatus == 404) {
        	$window.location.href = appConfig.contextPath + appUrl.verificationComplete;
        } else if (((response.data.errors || [])[0] || {}).reason) {
            messageService.errorWithReason(response.data.errors[0].reason, response.data.errors[0].field, true);
        } else if (response.data.exception) {
            messageService.errorWithReason(response.data.exception, null, true);
        } else {
            messageService.error(gettextCatalog.getString('A problem was encountered when saving. Please try again.'));
        }
    },
    
	$scope.validatePassword = function() {
		$scope.errors = null;
		let valid = true;
		const errors = {};

		// Check for mandatory fields
		if (utils.hasNoValue($scope.form.password)) {
			errors.password = gettextCatalog.getString('A password must be chosen');
			valid = false;
		}
		if (!(/\d/.test($scope.form.password))) {
			errors.password = gettextCatalog.getString('Passwords must include a number');
			valid = false;
		}
		if (!(/[A-z]/.test($scope.form.password))) {
			errors.password = gettextCatalog.getString('Passwords must include a letter');
			valid = false;
		}
		if ($scope.form.password.length < 8) {
			errors.password = gettextCatalog.getString('Passwords must be over 8 characters');
			valid = false;
		}

        if (!(/[A-z]/.test($scope.form.password))) {
            errors.password = gettextCatalog.getString('Passwords must include a letter');
            valid = false;
        }

        if ((/(.)(\1){2,}/.test($scope.form.password))) {
            errors.password = gettextCatalog.getString('Passwords can\'t contain any character more than 3 time in succession.');
            valid = false;
        }

        if (!(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test($scope.form.password))) {
            errors.password = gettextCatalog.getString('Passwords must include a special character');
            valid = false;
        }

		if ($scope.form.password !== $scope.passwordConfirm) {
			errors.password = gettextCatalog.getString('Passwords do not match');
			valid = false;
		}
		$scope.errors = errors;

		return valid;
	},
    
    $scope.completeRegistration = function() {
        if (!($scope.validatePassword())) {
        	return;
        }
	    if ($scope.ispartner && !$scope.accepted) {
            $scope.errors = {checkbox: 'Please click the checkbox to accept terms and conditions.'};
            return;
        }    

		verificationService.completeRegistration($scope.form).then(
            (promise) => {
                $scope.verificationCallback(promise);
            }, (promise) => {
                $scope.verificationCallback(promise);
            }
        );

        // Show the spinner
        $scope.saving = true;
    },
    
    $scope.fetchDocument = function(type) {
        const termCondition = {
            locale: getLocaleLanguage(),
            type
        };

        const path = appConfig.serverHost + '/' + appConfig.serverPath +
            '/terms/getTerms?serviceCode=qkr&serviceFunctionCode=qkr-nonmpreg&consentCategory=legalcontent&'+
            'useCategoryCode=' + termCondition.type +'&locale='+termCondition.locale;
        $window.open(path, '_blank');
    };
});



// WEBPACK FOOTER //
// ./src/controllers/verification.controller.js